module.exports = __webpack_public_path__ + "img/edgar-l.372de50c.png";